import { ThirtyFps, Try } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { getSignatureListByUser } from "Services/docForm.service";

export const useSignatureForms = () => {
    const [signatureImage, setSignatureImage] = useState(null);

    useEffect(() => {
        getSignatureList();
    }, []);

    const getSignatureList = async () => {
        try {
        const res = await getSignatureListByUser();
        const payload = res?.data ?? res;
        const url = payload?.signatureUrl;
        if (!url) {
            setSignatureImage(null);
            return;
        }
        setSignatureImage(url);
        } catch (error) {
            console.error("Error fetching signature list:", error);
            setSignatureImage(null);
        }
    };

    return {
        signatureImage,
        getSignatureList,
    };
};